import { envConfig } from '../../../../env';
import { Get, Post } from '@/service/request/server';

let baseUrl = envConfig.formalServer + '/cotton/unc';

export function queryUserNoticeConfigList(data) {
    return Post(baseUrl + '/queryUserNoticeConfigList', data);
}

export function insertUserNoticeConfig(data) {
    return Post(baseUrl + '/insertUserNoticeConfig', data);
}

export function deleteUserNoticeConfig(data) {
    return Post(baseUrl + '/deleteUserNoticeConfig', data);
}

export function updateUserNoticeConfig(data) {
    return Post(baseUrl + '/updateUserNoticeConfig', data);
}

export function verifyAccount(configId, incomingSecretKey) {
    return Get(`${baseUrl}/verifyAccount/${configId}/${incomingSecretKey}`);
}

export function resendAuthenticationInfo(data) {
    return Post(baseUrl + '/resendAuthenticationInfo', data);
}